import { useState } from "react";
import "./Login.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faScaleBalanced,
    faEnvelope,
    faLock,
    faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import base_url from "../api";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showResend, setShowResend] = useState(false);
    const [resending, setResending] = useState(false);
    const [resentMessage, setResentMessage] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setShowResend(false);
        setResentMessage("");
        setLoading(true);

        try {
            const response = await fetch(`${base_url}/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email,
                    password,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                if (data.verificationRequired) {
                    setShowResend(true);
                }
                throw new Error(data.message || "Login failed");
            }

            // Store token and user info
            localStorage.setItem("token", data.token);
            localStorage.setItem("user", JSON.stringify(data.user));

            // Dispatch custom event to update header
            window.dispatchEvent(new Event("authChange"));

            // Redirect to profile page
            navigate("/my-profile");
        } catch (err) {
            setError(err.message || "Failed to login. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleResend = async () => {
        if (!email) {
            setError("Enter your email above to resend verification.");
            return;
        }

        setResending(true);
        setError("");
        setResentMessage("");

        try {
            const response = await fetch(`${base_url}/resend-verification`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Failed to resend verification email.");
            }

            setResentMessage(data.message || "Verification email sent. Check your inbox.");
        } catch (err) {
            setError(err.message || "Failed to resend verification email.");
        } finally {
            setResending(false);
        }
    };

    return (
        <section className="login-section">
            <div className="login-overlay"></div>

            <div className="login-wrapper">
                {/* Logo */}
                <div className="login-logo">
                    <FontAwesomeIcon icon={faScaleBalanced} />
                    <div>
                        <h3>Sandy Randhawa</h3>
                        <span>Family Law Solicitor</span>
                    </div>
                </div>

                {/* Card */}
                <div className="login-card">
                    <h2>Welcome Back</h2>
                    <p className="login-sub">
                        Sign in to access your client portal
                    </p>

                    <form onSubmit={handleSubmit}>
                        {/* Email */}
                        <div className="password-row">
                            <label>Email</label>
                        </div>            
                        <div className="input-group">
                            <FontAwesomeIcon icon={faEnvelope} />
                            <input
                                type="email"
                                placeholder="your@email.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        {/* Password */}
                        <div className="password-row">
                            <label>Password</label>
                            <Link to="/forgot-password" className="forgot">
                                Forgot password?
                            </Link>
                        </div>

                        <div className="input-group">
                            <FontAwesomeIcon icon={faLock} />
                            <input
                                type="password"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>

                        {/* Remember */}
                        {/* <div className="remember-row">
              <label>
                <input type="checkbox" /> Remember me
              </label>
            </div> */}

                        {/* Error */}
                        {error && <p className="error">{error}</p>}
                        {resentMessage && <p className="info">{resentMessage}</p>}
                        {showResend && (
                            <button
                                type="button"
                                className="resend-btn"
                                onClick={handleResend}
                                disabled={resending}
                            >
                                {resending ? "Sending..." : "Resend verification email"}
                            </button>
                        )}

                        {/* Button */}
                        <button className="login-btn" disabled={loading}>
                            {loading ? "Signing In..." : "Sign In"}
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </form>

                    <p className="signup-text">
                        Don't have an account? <Link to="/register">Sign up</Link>
                    </p>

                    <div className="back-link">← Back to website</div>
                </div>

                <p className="login-note">
                    Your information is protected and confidential
                </p>
            </div>
        </section>
    );
};

export default Login;
